"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockRealpageUnits = exports.mockRealpageProperty = void 0;
var domain_1 = require("@genoa/domain");
exports.mockRealpageProperty = {
    property_id: 1,
    name: 'Meadowbrook',
    identity_biller_id: 1,
    location: {
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
        latitude: 42.03548163,
        longitude: -87.67851671,
    },
    integration_type: domain_1.IntegrationType.REALPAGE,
    billing_integration_type: 'REALPAGE',
    public_id: 'realpage-property-1',
    status: domain_1.BillerPropertyStatus.ACTIVE,
    pmc_id: 1,
    pmc_name: 'flex-dev',
    external_pmc_id: '4593629',
    external_property_id: '4593630',
    portal_id: null,
    created_at: '2023-01-20',
    updated_at: '2023-05-19',
    current_tier: null,
    qualified_tier: null,
};
exports.mockRealpageUnits = [
    {
        label: 'Building 1, Unit 510',
        unit: '510',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 511',
        unit: '511',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 100',
        unit: '100',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 101',
        unit: '101',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 200',
        unit: '200',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 300',
        unit: '300',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 201',
        unit: '201',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 103',
        unit: '103',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 202',
        unit: '202',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 400',
        unit: '400',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 104',
        unit: '104',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 500',
        unit: '500',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 203',
        unit: '203',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 204',
        unit: '204',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 303',
        unit: '303',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 105',
        unit: '105',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 501',
        unit: '501',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 403',
        unit: '403',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 304',
        unit: '304',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 502',
        unit: '502',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 205',
        unit: '205',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 503',
        unit: '503',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 404',
        unit: '404',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 405',
        unit: '405',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 108',
        unit: '108',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 109',
        unit: '109',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 505',
        unit: '505',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 307',
        unit: '307',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 308',
        unit: '308',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 407',
        unit: '407',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 507',
        unit: '507',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        label: 'Building 1, Unit 509',
        unit: '509',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
];
